// src/types/ai/AiPageContext.ts
var AiPageKind = /* @__PURE__ */ ((AiPageKind2) => {
  AiPageKind2["Listing"] = "listing";
  AiPageKind2["Booking"] = "booking";
  return AiPageKind2;
})(AiPageKind || {});

export {
  AiPageKind
};
